import React, { useEffect, useRef, useState } from "react";
import { getComprehensiveAIAnalysis } from "../../../services/aiAnalysisService";
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card, Typography, Button, Chip, LinearProgress, Box, Skeleton, CircularProgress,Dialog, DialogTitle, DialogContent, DialogActions,FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import IconButton from '@mui/material/IconButton';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { useStyles } from "../../../assets/styles/PatientDashboardStyles";
import {
  StyledInnerHeadingText,
  StyledSecondaryButton,
} from "../../../assets/styles/CommonStyles";
import strings from "../../../constant/strings";
import HeadingComponent from "../HeadingComponent/index.js";
import Lists from "../../controls/Lists";
import {
  HealthParameterList,
  LipidProfileList,
} from "../../../constant/staticLists";
import {
  bloodSugar,
  healthParams,
  lipidProfile,
  bloodPressure,
  bloodOxygen,
  bodyTemp,
  heartRate,
  respiratoryRate,
  getStepsData,
  getSleepData,
} from "../../../redux/user/userActions";
import EcgScrollImage from "../../EcgScrollImage";
import { usePatientHealthStyles } from "./style";
import TabComponent from "../../Tab";
import { getPatientAppointmentAction } from "../../../redux/appointment/patient/patientAppointmentActions";
import { commonMuiStyles } from "../../../assets/styles/CommonMUIStyles";
import { useHealthParameterStyles } from "../HealthParameters/style.js";
import HealthParameters from "../HealthParameters/index.js";
import { getAbnormalReportsApi, getAbnormalReportsByOrg, getAbnormalReportsBySubadmin, getAllECGByDateApi, getDoctorAbnormalReportsApi, getDoctorPatientECGByDateApi, getDoctorPatientLastEcgApi, getLastEcgApi } from "../../../services/mainService.js";
import ComprehensiveAIAnalysisModal from "../../Modal/ComprehensiveAIAnalysisModal.js";
import AIAnalysisConfigDialog from "../../Modal/AIAnalysisConfigDialog.js";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { getUser } from "../../../services/apiUrl.js";
const actionSagaMapping = {
  bloodPressureData: bloodPressure,
  bloodSugarData: bloodSugar,
  spo2sData: bloodOxygen,
  bodyTemperatureData: bodyTemp,
  respiratorieData: respiratoryRate,
  heartRateData: heartRate,
  stepsData: getStepsData,
  sleepData: getSleepData 

};



const PatientDashboard = ({ item, patientID }) => {

  // const classes = useStyles();
  const commonClasses = useStyles();
  const dispatch = useDispatch();
  const useHealthParameterClasses = useHealthParameterStyles();
  const patientHealthClassses = usePatientHealthStyles();
  const styleClasses = commonMuiStyles();
  const [showData, setShowData] = useState([]);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [aiConfigOpen, setAiConfigOpen] = useState(false);
  const [aiAnalysisData, setAiAnalysisData] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [abnormalReports, setAbnormalReports] = useState([]);
  const [loadingAbnormal, setLoadingAbnormal] = useState(false);
  const [loadingEcg, setLoadingEcg] = useState(false);
  const [ecgImage, setEcgImage] = useState(null);
  const [ecgModalOpen, setEcgModalOpen] = useState(false);
const [ecgModalDate, setEcgModalDate] = useState(moment().format('YYYY-MM-DD'));
const [ecgModalList, setEcgModalList] = useState([]);
const [ecgModalLoading, setEcgModalLoading] = useState(false);
const [ecgModalPage, setEcgModalPage] = useState(1);
const [ecgModalTotalPages, setEcgModalTotalPages] = useState(1);
const [selectedEcgId, setSelectedEcgId] = useState(null);
const [ecgDisplayDate, setEcgDisplayDate] = useState(null);
const [ecgSpeed, setEcgSpeed] = useState(25);
const [ecgImageLoading, setEcgImageLoading] = useState(false);

  const [duration, setDuration] = React.useState(
    HealthParameterList.reduce((prev, cur) => {
      prev[cur.primaryKey] = "w";
      return prev;
    }, {})
  );
  const classes = {
    ...commonClasses,
    ...patientHealthClassses, ...useHealthParameterClasses
  };
  const [date, setDate] = React.useState(
    HealthParameterList.reduce((prev, cur) => {
      prev[cur.primaryKey] = moment(new Date()).format("YYYY-MM-DD");
      return prev;
    }, {})
  );
  const [tabValue, setTabValue] = useState(0);
  const tabs = [
    { id: 0, name: "Today" },
    { id: 1, name: "Upcoming" },
  ];
  const prevDate = useRef(date);
  const prevDur = useRef(duration);
  const userType = getUser()
  const { userData, user } = useSelector((state) => ({
    userData: state.auth.userData,
    user: state.user,
  }));

  const updatedLipidProfileList = LipidProfileList.map((item) => {
    return {
      ...item,
      value: user[item.value],
    };
  });
  const { patientAppointmentList } = useSelector((state) => ({
    patientAppointmentList: state.appointment.patientAppointmentList || [],
  }));
  useEffect(() => {
    dispatch(getPatientAppointmentAction({ token: userData.token, status: 1 }));
  }, [])
  useEffect(() => {
    if (userType === "patient") {
      dispatch(
        getPatientAppointmentAction({
          token: userData.token,
          status: 1
        })
      );
    }
  }, [userType, userData.token]);
  const fetchAbnormalReports = async () => {
    try {
      setLoadingAbnormal(true);
      const res = await getAbnormalReportsApi({
        token: userData.token
      });

      if (res && res.response) {
        setAbnormalReports(res.response.data || []);
      }
    } catch (err) {
      console.error("Error fetching abnormal reports:", err);
    } finally {
      setLoadingAbnormal(false);
    }
  };

  const fetchDoctorAbnormalReports = async () => {
    try {
      setLoadingAbnormal(true);
      const appointmentId = item?._id;
      const res = await getDoctorAbnormalReportsApi({
        token: userData.token,
        appointmentId
      });
      if (res && res.response) {
        setAbnormalReports(res.response.data || []);
      }
    } catch (err) {
      console.error("Error fetching doctor abnormal reports:", err);
    } finally {
      setLoadingAbnormal(false);
    }
  };

  const fetchAbnormalReportsBySubadmin = async () => {
    try {
      setLoadingAbnormal(true);
      const id = patientID;
      const res = await getAbnormalReportsBySubadmin({
        token: userData.token,
        id
      });
      if (res && res.response) {
        setAbnormalReports(res.response.data || []);
      }
    } catch (err) {
      console.error("Error fetching abnormal reports by subadmin:", err);
    } finally {
      setLoadingAbnormal(false);
    }
  };

  const fetchAbnormalReportsByOrg = async () => {
    try {
      setLoadingAbnormal(true);
      const id = patientID;
      const res = await getAbnormalReportsByOrg({
        token: userData.token,
        id
      });
      if (res && res.response) {
        setAbnormalReports(res.response.data || []);
      }
    } catch (err) {
      console.error("Error fetching abnormal reports by subadmin:", err);
    } finally {
      setLoadingAbnormal(false);
    }
  };

const getBloodCoughECG = async () => {
  try {
    setLoadingEcg(true);
    const res = userType === 'doctor'
      ? await getDoctorPatientLastEcgApi({
          token: userData.token,
          appointmentId: item?._id,
        })
      : await getLastEcgApi({
          token: userData.token,
        });

    if (res && res.response && res.response.data) {
      setEcgImage(res.response.data.fileUrl || null);
      setEcgSpeed(res.response.data.speed || 25);
      setEcgDisplayDate(res.response.data.timestamp || null);
    }
  } catch (err) {
    console.error("Error fetching last ECG:", err);
  } finally {
    setLoadingEcg(false);
  }
};

const fetchAllEcg = async (date, page = 1) => {
  try {
    setEcgModalLoading(true);
    const res = userType === 'doctor'
      ? await getDoctorPatientECGByDateApi({
          token: userData.token,
          appointmentId: item?._id,
          date,
          page,
          limit: 5,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
      : await getAllECGByDateApi({
          token: userData.token,
          date,
          page,
          limit: 5,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

    if (res && res.response) {
      setEcgModalList(res.response.data?.data || []);
      setEcgModalTotalPages(res.response.data?.pagination?.totalPages || 1);
    }
  } catch (err) {
    console.error('Error fetching ECG by date:', err);
  } finally {
    setEcgModalLoading(false);
  }
};

const handleEcgModalClose = () => {
  setEcgModalOpen(false);
  setSelectedEcgId(null);
  setEcgModalDate(moment().format('YYYY-MM-DD'));
  setEcgModalList([]);
  setEcgModalPage(1);
  setEcgModalTotalPages(1);
};


  // Helper function to get max 3 items
  const displayedReports = abnormalReports.slice(0, 3);
  const hasMoreReports = abnormalReports.length > 3;

useEffect(() => {
  if (userData?.userType === 'patient') {
    fetchAbnormalReports();
    getBloodCoughECG();         
  } else if (userData?.userType === 'doctor' && item?._id) {
    fetchDoctorAbnormalReports();
    getBloodCoughECG();          
  } else if (userData?.userType === 'subadmin' && patientID) {
    fetchAbnormalReportsBySubadmin();
  } else if (userData?.userType === 'organization' && patientID) {
    fetchAbnormalReportsByOrg();
  }
}, []);

  useEffect(() => {
    if (
      patientAppointmentList === null ||
      patientAppointmentList.length === 0
    ) {
      setShowData([]);
      return;
    }
    let data = JSON.parse(JSON.stringify(patientAppointmentList));
    data.sort(
      (a, b) =>
        moment(a.start_time).format("YYYY-MM-DDTHH:mm") -
        moment(b.start_time).format("YYYY-MM-DDTHH:mm")
    );

    if (!tabValue) {
      const today = moment().startOf("day");
      const todayFilteredData = data.filter((item) => {
        const itemDate = moment(item.start_time);
        return itemDate.isSame(today, "day");
      });
      if (todayFilteredData.length) {
        const now = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        const filteredData = todayFilteredData.filter((item) => {
          const itemDate = moment(item.start_time);
          return itemDate.isSameOrAfter(now);
        });
        console.log("data", filteredData)
        setShowData(filteredData);
      } else {
        setShowData([]);
      }
    } else {
      const todayDate = moment().format('YYYY-MM-DD');
      const futureAppointments = data.filter(item =>
        moment(item.start_time).isAfter(todayDate, 'day'))
      if (futureAppointments?.length) {
        setShowData(futureAppointments);
      }
      else {
        setShowData([]);
      }
    }
  }, [patientAppointmentList, tabValue]);
  useEffect(() => {
    let changed;
    const preValues = Object.entries(prevDur.current);
    const values = Object.entries(duration);
    preValues.forEach((element, index) => {
      if (element[1] !== values[index][1]) changed = values[index];
    });
    prevDur.current = duration;
    if (changed) {
      if (userType === "patient") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: changed[1],
            date: date[changed[0]],
          })
        );
      }
      else if (userType === "doctor") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: changed[1],
            date: date[changed[0]],
            appointmentId: item?._id
          })
        );
      }
      else if (userType === "organization" || userType === "subadmin") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: changed[1],
            date: date[changed[0]],
            patientId: patientID
          })
        );
      }
    }
  }, [duration]);

  const history = useHistory();

  useEffect(() => {
    let changed;
    const preValues = Object.entries(prevDate.current);
    const values = Object.entries(date);
    preValues.forEach((element, index) => {
      if (element[1] !== values[index][1]) changed = values[index];
    });
    prevDate.current = date;
    if (changed) {
      if (userType === "patient") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: duration[changed[0]],
            date: changed[1],
          })
        );
      }
      else if (userType === "doctor") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: duration[changed[0]],
            date: changed[1],
            appointmentId: item?._id
          })
        );
      }
      else if (userType === "organization" || userType === "subadmin") {
        dispatch(
          actionSagaMapping[changed[0]]({
            token: userData.token,
            duration: duration[changed[0]],
            date: changed[1],
            patientId: patientID
          })
        );
      }
    }
  }, [date]);

  useEffect(() => {
    let date = moment().utc().format("YYYY-MM-DD");
    if (userType === 'patient') {
      date = item?.start_time
        ? moment(item.start_time).utc().format("YYYY-MM-DD") : ''
    }
    let id = userType === "doctor" ? item._id : (userType === "organization" || userType === "subadmin") ? patientID : ""

    if (userType === 'doctor') { dispatch(healthParams({ token: userData.token, duration: "w", appointmentId: id, date: date })) }
    else if (userType === 'organization' || userType === "subadmin") { dispatch(healthParams({ token: userData.token, duration: "w", patientId: id, date: date })) }
    else {
      dispatch(lipidProfile({ token: userData.token, duration: "w", date: date }))
    }
    //dispatch(lipidProfile({ token: userData.token, duration: "w", appointmentId: id, date: date }))
    //dispatch(healthParams({ token: userData.token, duration: "w", appointmentId: id, date: date }));
    //setTimeout(() => dispatch(heartRate({ token: userData.token, duration: "w", appointmentId: id, date: date })), 0);
  }, [userData?.token, userType, item?._id, patientID, dispatch]);

  // useEffect(() => {
  //   userType === "patient" && dispatch(
  //     getPatientAppointmentAction({
  //       token: userData.token,
  //       search: "",
  //       status: 1,
  //     })
  //   );
  // }, []);

  const handleTab = (e, value) => {
    setTabValue(value);
  };

  const handleAIAnalysis = async ({ duration, date }) => {
    setAiModalOpen(true);
    setAiLoading(true);
    try {
      const payload = {
        token: userData.token,
        duration,
        date,
      };

      // Add context IDs based on user type
      if (userType === 'doctor') {
        payload.appointmentId = item?._id || '';
      } else if (userType === 'organization' || userType === 'subadmin') {
        payload.patientId = patientID || '';
      }

      const apiResponse = await getComprehensiveAIAnalysis(payload);

      if (apiResponse.response_type === 'success' && apiResponse.response?.ai_data) {
        setAiAnalysisData({ ...apiResponse.response.ai_data, duration, endDate: date });
      } else {
        setAiAnalysisData(null);
      }
    } catch (error) {
      console.error('AI Analysis Error:', error);
      setAiAnalysisData(null);
    } finally {
      setAiLoading(false);
    }
  };

  return (
    <Grid container spacing={0} >
      {userType === 'patient' &&
        <Grid item xs={12} className={classes.mainCont}>
          <HeadingComponent
            text={{ primary: strings.home, secondary: strings.homeHeadingText }}
          />
        </Grid>}
      <Grid item xs={12}>
        <Grid container spacing={0}>
          {userType === 'patient' && <Grid item xs={12} sm={12} md={4} lg={3} className={classes.appointMainCont}>
            <div className={classes.appointmentTextStyle}>
              {strings.appointments}
            </div>

            <div className={classes.detailCont}>
              <TabComponent
                tabs={tabs}
                tabValue={tabValue}
                setTabValue={setTabValue}
                handleTab={handleTab}
                customTab={`${styleClasses.customTab} ${classes.fontSize}}`}
                customTabIndicator={styleClasses.customTabIndicator}
              />
              {showData.length === 0 ? (
                <div className={classes.marginTop}>
                  <div className={classes.appointmentTextStyle}>
                    No Appointments
                  </div>
                </div>
              ) : (
                <div>
                  <Grid
                    container
                    spacing={0}
                    className={classes.appointmentCont}
                  >
                    <Grid item xs={1}>
                      <img
                        src={"/assets/img/doctor-empty.png"}
                        alt="doctor-img"
                        style={{ height: "18px", width: "18px" }}
                      />
                    </Grid>
                    <Grid item xs={8} className={classes.appointmentTextStyle}>
                      {showData[0].doctorInfo.name}
                    </Grid>
                    <Grid item xs={12} className={classes.content}>
                      {showData[0].doctorInfo.department}{" "}
                      {showData[0].appointment_type === 0
                        ? " : Online"
                        : ": In-Person"}
                    </Grid>
                    {!tabValue ? (
                      <Grid item xs={12} className={classes.content}>
                        Today ·{" "}
                        {moment(showData[0].start_time).format("hh:mm")} -
                        {moment(showData[0].end_time).add(1, 'seconds').format("hh:mm A")}
                      </Grid>
                    ) : (
                      <Grid item xs={12} className={classes.content}>
                        {moment(showData[0].start_time).format("YYYY-MM-DD")}{" "} ·{" "}
                        {moment(showData[0].start_time).format("hh:mm")}{" "}-{" "} {moment(showData[0].end_time).add(1, 'seconds').format("hh:mm A")}
                      </Grid>
                    )}
                  </Grid>
                </div>
              )}
            </div>
            <div
              className={classes.buttonCont}
              onClick={() => history.push("/patient/appointment-listing")}
            >
              {strings.viewMore}
            </div>
          </Grid>
          }
          <Grid
            item
            xs={12}
            sm={12}
            md={userType === "patient" ? 7.8 : 12}
            lg={userType === "patient" ? 8.8 : 12}
            className={classes.ecgCont}
            sx={{ position: "relative" }}
          >

            {loadingEcg || ecgImageLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", minHeight: "250px", bgcolor: "#fff" }}>
                <CircularProgress size={40} />
              </Box>
            ) : ecgImage ? (
              <EcgScrollImage src={ecgImage} />  
            ) : (
              <EcgScrollImage />
            )}

            {ecgImage && (
              <Box sx={{
                position: "absolute", top: 10, left: 10, zIndex: 99,
                background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                borderRadius: "6px",
                px: 1.4, py: 0.5,
                display: "flex", alignItems: "center", gap: 0.5,
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
              }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 700, letterSpacing: "0.4px" }}>
                  ⚡ {ecgSpeed} mm/s
                </Typography>
              </Box>
            )}

            {ecgImage && ecgDisplayDate && (
              <Box sx={{
                position: "absolute", bottom: 12, left: 10, zIndex: 99,
                bgcolor: "rgba(0,0,0,0.72)",
                borderRadius: "6px",
                px: 1.4, py: 0.5,
                display: "flex", alignItems: "center", gap: 0.5,
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                backdropFilter: "blur(3px)",
              }}>
                <Typography sx={{ color: "#fff", fontSize: "12px", fontWeight: 600, letterSpacing: "0.3px" }}>
                  🕐 {moment.unix(ecgDisplayDate).format("DD MMM YYYY, hh:mm A")}
                </Typography>
              </Box>
            )}

            {ecgImage && (
              <Box sx={{ position: "absolute", bottom: 12, right: 12, zIndex: 99 }}>
                <Button
                  onClick={() => setEcgModalOpen(true)}
                  startIcon={<CalendarTodayIcon sx={{ fontSize: 15 }} />}
                  sx={{
                    background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "12px",
                    textTransform: "none",
                    borderRadius: "8px",
                    px: 1.5,
                    py: 0.6,
                    minWidth: "unset",
                    boxShadow: "0 2px 8px rgba(9,126,183,0.4)",
                    "&:hover": {
                      background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
                      boxShadow: "0 4px 14px rgba(9,126,183,0.6)",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.2s ease",
                  }}
                >
                  ECG History
                </Button>
              </Box>
            )}

          </Grid>

        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.innerCont}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

            <StyledInnerHeadingText>
              {strings.healthParameter}
            </StyledInnerHeadingText>
            {userType === 'patient' && (
              <Button
                onClick={() => setAiConfigOpen(true)}
                startIcon={<AutoAwesomeIcon sx={{ fontSize: 15 }} />}
                sx={{
                  background: "linear-gradient(135deg, #6C5CE7 0%, #a29bfe 100%)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "13px",
                  textTransform: "none",
                  borderRadius: "20px",
                  px: 2.5,
                  py: 0.9,
                  boxShadow: "0 2px 12px rgba(108,92,231,0.4)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5A4BD6 0%, #8f83f7 100%)",
                    boxShadow: "0 4px 18px rgba(108,92,231,0.55)",
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                ✦ AI Analysis
              </Button>
            )}
          </Box>

        </Box>
      </Grid>
      {/* <Grid item xs={12} className={classes.healthParameterCont}>
         <Lists
         list={HealthParameterList}
          className={classes}
          navigation="healthParameters"
          duration={duration}
          setDuration={setDuration}
          date={date}
          setDate={setDate}
         /> 
      </Grid>  */}
      <div mt={-30} className={classes.mainHealthCont}>
        <Grid container justify="center" className={classes.secondaryMainHealth}>
          <HealthParameters className={classes} list={HealthParameterList} duration={duration} setDuration={setDuration} date={date} setDate={setDate} patientID={patientID} item={item} />
        </Grid>
      </div>
      <Grid item xs={12} className={classes.innerCont}>
        <StyledInnerHeadingText>{strings.lipidProfile}</StyledInnerHeadingText>
      </Grid>
      <Grid item xs={12} className={classes.healthParameterCont}>
        <Lists
          list={updatedLipidProfileList}
          navigation="lipidParameters"
          data={bloodSugar}
          className={classes}
          duration={duration}
          setDuration={setDuration}
        />
      </Grid>

      <ComprehensiveAIAnalysisModal
        open={aiModalOpen}
        onClose={() => {
          setAiModalOpen(false);
          setAiAnalysisData(null);
        }}
        aiData={aiAnalysisData}
        loading={aiLoading}
      />

      <AIAnalysisConfigDialog
        open={aiConfigOpen}
        onClose={() => setAiConfigOpen(false)}
        onAnalyze={handleAIAnalysis}
      />

      {/* ----------------- ABNORMAL REPORTS SECTION ----------------- */}
      {/* SECTION HEADER: Title + Always Visible 'View All' Button */}
      {(userData?.userType === 'patient' || userData?.userType === 'doctor' || userData?.userType === 'subadmin' || userData?.userType === 'organization') && (
        <>
          <Grid item xs={12} className={classes.innerCont} style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <StyledInnerHeadingText>Recent Abnormal Lab Reports</StyledInnerHeadingText>
            {userData?.userType === 'patient' && (
              <Button
                endIcon={<ArrowForwardIcon />}
                onClick={() => history.push({
                  pathname: '/patient/medical-record',
                  state: { activeTab: 3 }
                })}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                View All
              </Button>
            )}
          </Grid>

          <Grid item xs={12} style={{ padding: '0px 15px 30px 15px' }}>

            {/* STATE 1: SINGLE COMMON LOADER / ANALYSING */}
            {loadingAbnormal ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 6,
                  bgcolor: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.03)'
                }}
              >
                <CircularProgress size={30} sx={{ color: '#097EB7', mb: 2 }} />
                <Typography variant="body1" sx={{ color: '#555', fontWeight: 500 }}>
                  Analysing Reports...
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Scanning for health anomalies
                </Typography>
              </Box>

              /* STATE 2: NO RECORDS FOUND (Success State) */
            ) : abnormalReports.length === 0 ? (
              <Box
                sx={{
                  p: 4,
                  textAlign: 'center',
                  bgcolor: '#f0fff4',
                  borderRadius: '12px',
                  border: '1px dashed #2ecc71'
                }}
              >
                <CheckCircleOutlineIcon sx={{ fontSize: 40, color: '#2ecc71', mb: 1 }} />
                <Typography variant="h6" sx={{ color: '#27ae60', fontWeight: 'bold' }}>
                  No Abnormalities Detected
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Your recent scanned reports look good. Keep it up!
                </Typography>
              </Box>

              /* STATE 3: SHOW DATA (Max 3) */
            ) : (
              <Grid container spacing={3}>
                {displayedReports.map((report, index) => {
                  const total = report.summary.totalTests || 1;
                  const normal = report.summary.normalCount || 0;
                  const healthPercentage = (normal / total) * 100;

                  const abnormalDetails = report.abnormalParameters || [];

                  return (
                    <Grid item xs={12} sm={6} md={4} key={report._id || index}>
                      <Card sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "12px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        borderLeft: "6px solid #e74c3c",
                        transition: "transform 0.2s",
                        "&:hover": { transform: "translateY(-4px)" }
                      }}>
                        {/* Header */}
                        <Box sx={{ p: 2, pb: 1 }}>
                          <Box display="flex" justifyContent="space-between">
                            <Box>
                              <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: "700" }}>{report.reportType}</Typography>
                              <Typography variant="caption" sx={{ color: "#888" }}>
                                {moment(report.createdAt).format("DD MMM YYYY")}
                              </Typography>
                            </Box>
                            <Box sx={{ bgcolor: "#ffebee", borderRadius: "50%", p: 1, display: 'flex' }}>
                              <WarningAmberRoundedIcon sx={{ color: "#e74c3c", fontSize: 20 }} />
                            </Box>
                          </Box>
                        </Box>

                        {/* Body */}
                        <Box sx={{ px: 2, py: 1, flexGrow: 1 }}>
                          <Typography variant="subtitle2" sx={{ color: "#e74c3c", fontWeight: "bold", mb: 1 }}>
                            ⚠️ {report.summary.abnormalCount} Abnormal Values
                          </Typography>

                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                            {abnormalDetails.map((test, idx) => (
                              <Chip
                                key={idx}
                                label={`${test.parameter}: ${test.status}`}
                                size="small"
                                sx={{ bgcolor: "#ffebee", color: "#c62828", fontSize: "0.7rem", fontWeight: 600, height: '24px' }}
                              />
                            ))}
                          </Box>

                          <Box sx={{ mt: 'auto' }}>
                            <LinearProgress
                              variant="determinate"
                              value={healthPercentage}
                              sx={{
                                height: 6,
                                borderRadius: 5,
                                bgcolor: "#f1f2f6",
                                "& .MuiLinearProgress-bar": { bgcolor: healthPercentage > 80 ? "#f1c40f" : "#e74c3c" }
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Footer */}
                        {/* <Box sx={{ p: 2, pt: 1, borderTop: "1px solid #f5f6fa" }}>
                       <Button 
                         fullWidth 
                         size="small" 
                         variant="outlined" 
                         sx={{ borderColor: "#17a2b8", color: "#17a2b8", textTransform: 'none' }} 
                         onClick={() => window.open(report.source?.fileName, '_blank')}
                       >
                          View Report
                       </Button>
                    </Box> */}
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Grid>
        </>
      )}
      <Dialog
        open={ecgModalOpen}
        onClose={() => setEcgModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <DialogTitle sx={{
          fontWeight: 700,
          background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}>
          Browse ECG by Date
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>Select Date</Typography>
            <input
              type="date"
              value={ecgModalDate}
              max={moment().format('YYYY-MM-DD')}
              onChange={(e) => {
                setEcgModalDate(e.target.value);
                setEcgModalPage(1);
                setEcgModalList([]);
                setSelectedEcgId(null);
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
                outline: "none",
              }}
            />
            <Button
              variant="contained"
              onClick={() => fetchAllEcg(ecgModalDate, 1)}
              sx={{
                mt: 1.5,
                width: "100%",
                background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                "&:hover": {
                  background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
                },
              }}
            >
              Search ECG Records
            </Button>
          </Box>
          {ecgModalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={30} sx={{ color: "#097EB7" }} />
            </Box>
          ) : ecgModalList.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography color="textSecondary">No ECG records found for this date.</Typography>
            </Box>
          ) : (
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Select ECG Record</InputLabel>
              <Select
                value={selectedEcgId || ""}
                label="Select ECG Record"
                onChange={(e) => setSelectedEcgId(e.target.value)}
                MenuProps={{ PaperProps: { sx: { maxHeight: 260 } } }}
              >
                {ecgModalList.map((ecg) => (
                  <MenuItem key={ecg._id} value={ecg._id}>
                    <Box sx={{ display: "flex", flexDirection: "column", py: 0.5 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {moment.unix(ecg.timestamp).format("DD MMM YYYY, hh:mm A")}
                        {ecg.heartRate ? `  •  ${ecg.heartRate} BPM` : ""}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#888" }}>
                        Device: {ecg.type || "Unknown Device"}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {ecgModalTotalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mt: 2 }}>
              <Button
                size="small"
                disabled={ecgModalPage === 1}
                onClick={() => {
                  const prev = ecgModalPage - 1;
                  setEcgModalPage(prev);
                  fetchAllEcg(ecgModalDate, prev);
                }}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 600,
                }}
              >
                ← Prev
              </Button>
              <Typography variant="body2">{ecgModalPage} / {ecgModalTotalPages}</Typography>
              <Button
                size="small"
                disabled={ecgModalPage === ecgModalTotalPages}
                onClick={() => {
                  const next = ecgModalPage + 1;
                  setEcgModalPage(next);
                  fetchAllEcg(ecgModalDate, next);
                }}
                sx={{
                  textTransform: "none",
                  background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 600,
                }}
              >
                Next →
              </Button>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setEcgModalOpen(false)} sx={{ textTransform: "none", color: "#888" }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!selectedEcgId}
            onClick={() => {
              const selected = ecgModalList.find((e) => e._id === selectedEcgId);
              if (selected?.fileUrl) {
                setEcgModalOpen(false);
                setEcgImageLoading(true);

                setTimeout(() => {
                  setEcgImage(selected.fileUrl);
                  setEcgSpeed(selected.speed || 25);
                  setEcgDisplayDate(selected.timestamp || null);
                  setEcgImageLoading(false); 
                }, 800);
              }
              setSelectedEcgId(null);
              setEcgModalDate(moment().format('YYYY-MM-DD'));
              setEcgModalList([]);
              setEcgModalPage(1);
              setEcgModalTotalPages(1);
            }}
            onClose={handleEcgModalClose}
            sx={{
              background: "linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: "linear-gradient(90deg, #0870a0 0%, #238B5B 100%)",
              },
            }}
          >
            Show ECG
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PatientDashboard;
